// Globals
import React, { useCallback } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

import {
  faPlay,
  faPause,
  faForward,
  faBackward,
} from '@fortawesome/free-solid-svg-icons';

import styles from './Player.module.css';
import {
  adjustPlayerTime,
  setLeftSideTabState,
  setPlayingState,
} from '../../actions';

// Types
import { IState } from '../../graphql/types';
import { Button, ConfigProvider } from 'antd';
import { playButtonTheme } from '../../theme';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { LoadingOutlined } from '@ant-design/icons';

const NewPlayer = ({ loading }) => {
  const dispatch = useDispatch();

  let playing = useSelector<IState, boolean>(state => !!state.player?.playing);

  const togglePlaying = React.useCallback(() => {
    if (loading) {
      return;
    }

    batch(() => {
      dispatch(setPlayingState(!playing));
      dispatch(setLeftSideTabState('feed'));
    });
  }, [dispatch, playing, loading]);

  const seekBack15 = useCallback(() => {
    dispatch(adjustPlayerTime(-15));
  }, [dispatch]);

  const seekForward15 = useCallback(() => {
    dispatch(adjustPlayerTime(15));
  }, [dispatch]);

  const playingControls = useCallback(
    () => (
      <div className={styles.buttons}>
        <Button
          onClick={seekBack15}
          type={'primary'}
          shape={'circle'}
          size={'large'}
          className={styles.backButton}
        >
          <FontAwesomeIcon icon={faBackward} />
          <span className={styles.seekButtonElement}>15</span>
        </Button>
        <Button
          type={'primary'}
          shape={'circle'}
          size={'large'}
          onClick={togglePlaying}
          className={styles.squareButton}
        >
          <FontAwesomeIcon icon={faPause} />
        </Button>
        <Button
          onClick={seekForward15}
          type={'primary'}
          shape={'circle'}
          size={'large'}
          className={styles.forwardButton}
        >
          <span className={styles.seekButtonElement}>15</span>
          <FontAwesomeIcon icon={faForward} />
        </Button>
      </div>
    ),
    [togglePlaying, seekBack15, seekForward15]
  );

  const notPlayingControls = useCallback(
    () => (
      <Button
        type={'primary'}
        shape={'circle'}
        size={'large'}
        onClick={togglePlaying}
      >
        {!loading ? (
          <div className={styles.playButton}>
            <FontAwesomeIcon icon={faPlay} />
          </div>
        ) : (
          <LoadingOutlined spin />
        )}
      </Button>
    ),
    [togglePlaying, loading]
  );

  return (
    <ConfigProvider theme={playButtonTheme}>
      <div className={styles.player}>
        {playing ? playingControls() : notPlayingControls()}
      </div>
    </ConfigProvider>
  );
};

export default NewPlayer;
